import { UserDataCard } from 'app/src/features/UserInfo/components/UserDataCard'
import { membershipApi } from 'app/src/services/welfareportal'
import { getFromSessionStorage } from 'app/src/shared/helpers'

import { useMemo, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { string } from 'yup'

export function UserDataSection(props: {
  userInfo: membershipApi.MembershipInfo
  acceptIban: boolean
  membershipId: string
}): ReactElement {
  const { t } = useTranslation('userInfo', { keyPrefix: 'UserInfo.UserPropertyForm' })

  const emailYupCondition = useMemo(
    () => string().email(t('ValidationMessages.Format.Email')).required(t('ValidationMessages.Required.Email')),
    [t],
  )

  const ibanYupCondition = useMemo(() => string().required(t('ValidationMessages.Required.Iban')), [t])

  const campaignStorage = getFromSessionStorage('selectedCampaign') ?? '{}'

  return props?.userInfo ? (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
      <div className='flex flex-col'>
        <UserDataCard
          membershipId={props.membershipId}
          propertyDisplayName='Email'
          propertyName='userEmail'
          propertyValue={props.userInfo?.userEmail}
          yupCondition={emailYupCondition}
          propertyFormatter={{ format: (str: string | undefined) => str?.toLowerCase() }}
          showEdit={JSON.parse(campaignStorage)?.active}
        ></UserDataCard>
      </div>
      {props.acceptIban && (
        <div className='flex flex-col'>
          <UserDataCard
            membershipId={props.membershipId}
            propertyDisplayName='IBAN'
            propertyName='userIban'
            propertyValue={props.userInfo?.userIban}
            yupCondition={ibanYupCondition}
            propertyFormatter={{ format: (str: string | undefined) => str?.toUpperCase() }}
            showEdit={props.userInfo?.allowUserIbanEditing && JSON.parse(campaignStorage)?.active}
          ></UserDataCard>
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}
